import React from 'react';
import ReactDOM from 'react-dom';
import CorePage from '../core/CorePage';
import HmEventRegistry from '../../model/HmEventRegistry';

export default class DefaultMask extends CorePage{
	render(){
	const type = (this.props.maskProp && this.props.maskProp.maskType) ?  this.props.maskProp.maskType : "Triangle";

		return(
			<div className="overlay_cont">
			{this.showLoader(type)}
			</div>
			);
		}
	}

	HmEventRegistry.registerEvent("SHOW_MASK",function(maskProp){
		ReactDOM.render(<DefaultMask maskProp={maskProp}/>, document.getElementById('subroot'));	
	});

	HmEventRegistry.registerEvent("HIDE_MASK",function(){
		ReactDOM.unmountComponentAtNode(document.getElementById('subroot'));
	});


// WEBPACK FOOTER //
// ./src/views/common/DefaultMask.js